import { render } from "./passwordList.vue?vue&type=template&id=a4ebf9b2"
import script from "./passwordList.vue?vue&type=script&lang=js"
export * from "./passwordList.vue?vue&type=script&lang=js"

import "./passwordList.vue?vue&type=style&index=0&id=a4ebf9b2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__